import { render, staticRenderFns } from "./MobileAppScreen.vue?vue&type=template&id=42dc7910&scoped=true&"
import script from "./MobileAppScreen.vue?vue&type=script&lang=js&"
export * from "./MobileAppScreen.vue?vue&type=script&lang=js&"
import style0 from "./MobileAppScreen.vue?vue&type=style&index=0&id=42dc7910&scoped=true&lang=css&"
import style1 from "./MobileAppScreen.vue?vue&type=style&index=1&id=42dc7910&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dc7910",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42dc7910')) {
      api.createRecord('42dc7910', component.options)
    } else {
      api.reload('42dc7910', component.options)
    }
    module.hot.accept("./MobileAppScreen.vue?vue&type=template&id=42dc7910&scoped=true&", function () {
      api.rerender('42dc7910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobile/MobileAppScreen.vue"
export default component.exports